import { render, staticRenderFns } from "./listar-pacientes.vue?vue&type=template&id=796a124e&"
import script from "./listar-pacientes.vue?vue&type=script&lang=js&"
export * from "./listar-pacientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports